/**
 * PostHog feature-flags
 */
export const ANALYZE_BILLING_FLOW_FLAG = 'analyze-billing-flow';

/**
 * Rollout switch for the design-month gate, which holds a newly submitted revision behind a
 * contact prompt when its organization has no design month left for it. Off wherever the flag is
 * unset, except in dev, where `useFeatureFlag` treats an unset flag as on.
 */
export const DESIGN_MONTH_GATE_FLAG = 'design-month-gate';

/**
 * Kill switch for the in-app document-compliance gate. Grace is anchored to each
 * document's effective date, not to signup, so every organization that has never
 * accepted is already past it: enabling this gates all of them at once.
 * Fails closed outside dev, where `useFeatureFlag` forces it on.
 */
export const DOCUMENT_COMPLIANCE_GATE_FLAG = 'document-compliance-gate';

/**
 * Shows the package editor's Boundaries tab rows view: absolute maximum ratings and operating
 * conditions as the datasheet printed them, beside the flat table. Off wherever the flag is unset,
 * which leaves the tab as the flat table alone.
 */
export const PACKAGE_EDITOR_RATINGS_ROWS_FLAG = 'package-editor-ratings-rows';

/**
 * Lets a rating row's preview be edited: evaluated values typed for an expression the engine cannot
 * read, and bounds added, changed or removed over what the expression expands to, each kept as an
 * override on the row. Off wherever the flag is unset, which leaves every preview read-only; the
 * overrides a row already carries still show. An escape hatch, kept off until a datasheet needs it.
 */
export const PACKAGE_EDITOR_RATINGS_OVERRIDES_FLAG = 'package-editor-ratings-overrides';
